import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { ExposureDashboardAction } from './exposureDashboard.action';
import { exposureDashboardInitialState } from './exposureDashboard.constant';

export const exposureDashboardReducer = reducerWithInitialState(exposureDashboardInitialState)
  .case(ExposureDashboardAction.setFilter, (state, payload) => ({
    ...state,
    filter: {
      ...state.filter,
      ...payload,
    },
  }))
  .case(ExposureDashboardAction.setViewMode, (state, viewMode) => ({
    ...state,
    viewMode,
  }))
  .case(ExposureDashboardAction.destroy, () => ({
    ...exposureDashboardInitialState,
  }));
